import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-barcode',
    templateUrl: './barcode.component.svg',
    styleUrls: ['./barcode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarcodeComponent {}
